import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import IntakePage from "@/pages/IntakePage";
import Pricing from "@/pages/Pricing";
import SubscriptionRequired from "@/pages/SubscriptionRequired";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import HelpGuide from "@/pages/HelpGuide";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const APP_NAME = process.env.REACT_APP_NAME || "BackOffice";
export const APP_URL = process.env.REACT_APP_URL || "http://localhost:3000";

export const AuthContext = React.createContext();

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [shop, setShop] = useState(null);

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => setShop(res.data))
        .catch(() => {
          setToken(null);
          localStorage.removeItem("token");
        });
    }
  }, [token]);

  const login = (newToken, shopData) => {
    setToken(newToken);
    setShop(shopData);
    localStorage.setItem("token", newToken);
  };

  const logout = () => {
    setToken(null);
    setShop(null);
    localStorage.removeItem("token");
  };

  // Protected route wrapper that checks subscription
  const ProtectedRoute = ({ children }) => {
    if (!token) {
      return <Navigate to="/login" />;
    }

    if (shop && shop.subscription_status === "expired") {
      return <Navigate to="/subscription-required" />;
    }

    return children;
  };

  return (
    <AuthContext.Provider value={{ token, shop, login, logout }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription-required"
              element={token ? <SubscriptionRequired /> : <Navigate to="/login" />}
            />
            <Route
              path="/subscription/success"
              element={token ? <SubscriptionSuccess /> : <Navigate to="/login" />}
            />
            <Route path="/intake/:shopSlug" element={<IntakePage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/help-guide" element={<HelpGuide />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthContext.Provider>
  );
}

import React from 'react';
import PrivacyPolicy from "./pages/PrivacyPolicy";
export default App;
